import {
  AUTH_LOGOUT_REQUIRED,
  AUTH_LOGOUT,
  ON_API_ERROR,
} from '../types';

export function handleError({message}) {
  return (message === AUTH_LOGOUT_REQUIRED) ?
    {type: AUTH_LOGOUT} :
    {type: ON_API_ERROR, error: message};
}

export function resetError() {
  return {type: ON_API_ERROR, error: null};
}

